import Loading from '$/components/loading/Loading';
import { CompanyService } from '$/services';
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toastError } from '$/store/toast/actions';
import PrivateDeclarationsGrid from '$/components/private-declaration-grid';
import * as Bixby from '$/core';

interface IDeclarationsPendingApprovalProps {
  dispatchToastError: (message: string) => Promise<void>;
}

const DeclarationsPendingApproval: React.FC<IDeclarationsPendingApprovalProps> = ({ dispatchToastError }) => {
  const [companyDeclarations, setCompanyDeclarations] = useState(
    undefined as Bixby.Models.AdminCompanyDeclarationViewModel[] | undefined
  );
  const [isLoading, setIsLoading] = useState(true);

  const handleFetchDeclarations = useCallback(async () => {
    try {
      setIsLoading(true);
      const results = await CompanyService.getDeclarationsForBixbyApproval();
      setCompanyDeclarations(results);
    } catch (err) {
      dispatchToastError('Unable to load companies');
      setCompanyDeclarations(undefined);
    } finally {
      setIsLoading(false);
    }
  }, [dispatchToastError]);

  useEffect(() => {
    if (handleFetchDeclarations) {
      handleFetchDeclarations();
    }
  }, [handleFetchDeclarations]);

  return isLoading ? (
    <Loading pageLevel />
  ) : !companyDeclarations ? (
    <p className="error">An error occurred trying to load pending approval declarations. Please try again later</p>
  ) : (
    <>
      <h3>Declarations Pending Bixby Approval</h3>
      <PrivateDeclarationsGrid
        companyDeclarations={companyDeclarations}
        handleFetchCompanies={handleFetchDeclarations}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchToastError: (message: string) => dispatch(toastError(message)),
});

export default connect(null, mapDispatchToProps)(DeclarationsPendingApproval);
